import {type FC} from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import cn from 'clsx'
import {getTranslation} from '~/localization/translation'
import type {ImprovedHomepageDataProps, RootLoaderResponse} from '~/types'
import {useReportWidgetSeen} from '~/hooks/analytic-hooks'
import {getDomainConfig} from '~/domains'
import ArticleCard from './article-card'

interface ArticlesProps {
  articles: ImprovedHomepageDataProps['articles']
}

const Articles: FC<ArticlesProps> = ({articles}) => {
  const {language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const {styles: domainStyles} = getDomainConfig(domain, locale)
  const [sectionRef] = useReportWidgetSeen({
    widget_name: 'improved-home-articles-section',
    widget_place: 'bottom',
  })

  const showArticles = articles && articles.length > 0
  if (!showArticles) return null
  return (
    <section ref={sectionRef} className={cn(domainStyles.UTILS_MAIN_CONTAINER, 'mx-auto mb-20 w-full tablet:mt-3')}>
      <div className="flex flex-col gap-y-2 mobile:gap-y-1">
        <span className="text-base font-semibold uppercase tracking-widest text-[#61C200] mobile:text-xs">
          {translations.ImprovedHomePage.Articles.title}
        </span>
        <h2 className="text-[32px] font-extrabold text-[#363636] mobile:text-2xl">
          {translations.ImprovedHomePage.Articles.latestArticles}
        </h2>
      </div>
      <div className="mt-5">
        <div className="grid grid-cols-3 gap-5 tablet:grid-cols-1 tablet:flex-col">
          {articles.map((article, index) => (
            <div key={`${article.id}-${index}`}>
              <ArticleCard article={article} cardIndex={index} />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Articles
